<template>
  <div class="pt-4">
    <div class="flex pb-4">
      <div class="flex-1">
        <div class="pr-1">
          <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
            <label
              class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8"
              >{{ languages.date.from }}</label
            >
            <datepicker
              :minimumView="'month'"
              :maximumView="'month'"
              :language="es"
              name="periodo_desde"
              id="periodo_desde"
              format="MMMM yyyy"
              :bootstrap-styling="true"
              v-model="datePickerStart.date"
              input-class="w-full focus:outline-none border-0"
              @input="setInputPickers"
            >
            </datepicker>
            </div>
        </div>
      </div>
      <div class="flex-1">
        <div class="pl-1">
          <div class="border border-zt-dark-300 rounded px-2 pt-1 relative">
            <label
              class="px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8"
              >{{ languages.date.to }}</label
            >
            <datepicker
                :minimumView="'month'"
                :maximumView="'month'"
                :language="es"
                name="periodo_hasta"
                id="periodo_hasta"
                format="MMMM yyyy"
                :bootstrap-styling="true"
                v-model="datePickerEnd.date"
                input-class="w-full focus:outline-none border-0"
                @input="setInputPickers"
              >
              </datepicker>
            </div>
        </div>
      </div>
      <div v-show="isResetDatesVisible" class="px-2 inline-flex items-center">
        <button
        data-vs-button="clear-inputs"
          @click="clearInputs"
          class="text-zt-primary-200 text-zt-xl focus:outline-none"
        >
          <zt-icon name="times-solid" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import { has } from 'lodash'

const formatInput = (date, format) => {
  return moment(date).format(format)
}

export default {
  name: 'DateFilter',
  components: {
    datepicker
  },
  inject: ['store'],
  data() {
    return {
      es:es,
      masks: {
        input: 'MM/YYYY',
      },
      datePickerStart: {
        date: '',
        menu: false,
      },
      datePickerEnd: {
        date: '',
        menu: false,
      },
      languages: {
        date: {
          from: this.$t('message.searchComponent.period.from'),
          to: this.$t('message.searchComponent.period.to'),
        },
      },
    }
  },
  computed: {
    minDateTo() {
      return this.datePickerStart.date
    },
    setInputStartDate() {
      if (!this.datePickerStart.date) {
        return null
      }
      return formatInput(this.datePickerStart.date, 'MM/YYYY')
    },
    setInputEndDate() {
      if (!this.datePickerEnd.date) {
        return null
      }
      return formatInput(this.datePickerEnd.date, 'MM/YYYY')
    },
    isResetDatesVisible() {
      return !!this.datePickerStart.date || !!this.datePickerEnd.date
    },
  },
  methods: {
    setInputPickers() {
      this.$emit('signed-date', {
        signed: {
          start: this.setInputStartDate,
          end: this.setInputEndDate,
        }
      })
    },
    clearInputs() {
      this.datePickerStart.date = ''
      this.datePickerEnd.date = ''
      this.$emit('signed-date', {
        signed: {
          start: '',
          end: '',
        },
      })
    },
    existHistoryProperty(property) {
      const { history: { params } } = this.store
      return has(params, property)
    }
  },
  created() {
    if (this.existHistoryProperty('periodFrom')) {
      this.datePickerStart.date = moment(`${this.store.history.params.periodFrom.split('/').reverse().join('-')}-01`).toDate()
    }
    if (this.existHistoryProperty('periodTo')) {
      this.datePickerEnd.date = moment(`${this.store.history.params.periodTo.split('/').reverse().join('-')}-01`).toDate()
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .vdp-datepicker__calendar {
  position: fixed;
}
</style>